module.exports = __webpack_public_path__ + "static/media/engine-red.25bdfb0f.svg";